// Welsh translation strings.
// Every piece of user-facing text in the app should live here (or in
// translations.en.js), referenced from components via useTranslation()'s
// t("dot.path.key") function.
//
// Lines marked "// TODO: translate" still contain the English source text
// because no Welsh translation was available yet — please replace these
// with real Welsh copy.

export const cy = {
    common: {
        brand: "Proffiliadur",
        errors: {
            serviceUnavailable: "Ni allwn gyrraedd y gwasanaeth dadansoddi ar hyn o bryd. Rhowch gynnig arall arni ymhen ychydig funudau.",
            analysisFailed: "Aeth rhywbeth o'i le wrth ddadansoddi eich testun. Gwiriwch eich cysylltiad a rhoi cynnig arall arni.",
            // Draft translation - please have a Welsh speaker review.
            unexpected: "Aeth rhywbeth annisgwyl o'i le. Ail-lwythwch y dudalen.",
        },
        // Draft translation - please have a Welsh speaker review.
        reload: "Ail-lwytho'r dudalen",
        back: "Dychwelyd"
    },

    header: {
        logoAlt: "Logo'r Proffiliadur",
        nav: {
            home: "Hafan",
            analyse: "Dadansoddi",
            compare: "Cymharu",
            features: "Nodweddion",
            about: "Am y Proffiliadur",
        },
    },

    landing: {
        bgWords: ["Mae", "Geiriau", "Enghreifftiol", "Yn", "Mynd", "Yma"], 
        description: "Disgrifiad o'r wefan",
        cta: "Rhowch gynnig arni",
    },

    inputBox: {
        title: "Mewnbwn Testun",
        clear: "Clirio",
        inputLabel: "Mewnbwn testun {name}",
        placeholder: "Rhowch eich testun yma...",
        words: "Geiriau: {count}",
        characters: "Llythrennau: {count}",
        // Draft translation - please have a Welsh speaker review.
        tooLong: "Mae'r testun yn rhy hir. Cyfyngwch gyflwyniadau i {max} gair neu lai.",
    },

    loading: {
        defaultMessage: "Wrthi'n dadansoddi'ch testun",
        compareMessage: "Wrthi'n dadansoddi'r ddau destun",
        sub: "Gall gwneud hyn gymryd ychydig eiliadau",
    },

    analysePage: {
        title: "Dadansoddiad Darllenadwyedd",
        subtitle: "Gwiriwch ddarllenadwyedd eich testun",
        inspectView: "Golwg gwirio",
        reanalyseCy: "Ail-ddadansoddi'r Testun yn Gymraeg", 
        reanalyseEn: "Ail-ddadansoddi'r Testun yn Saesneg", 
        analyseCy: "Dadansoddi yn Gymraeg", 
        analyseEn: "Dadansoddi yn Saesneg", 
        sampleText: "Testunau Sampl",
        sampleTextsWelsh: "Testunau Cymraeg",
        sampleTextsEnglish: "Testunau Saesneg",
        // Draft translations - please have a Welsh speaker review.
        sampleTextsError: "Methwyd llwytho'r testunau enghreifftiol. Rhowch gynnig arall arni cyn bo hir.",
        sampleTextsEmpty: "Nid oes testunau enghreifftiol ar gael.",
        sampleTextsEmptyForLanguage: "Nid oes testunau enghreifftiol ar gael ar gyfer yr iaith hon.",
    },

    comparePage: {
        title: "Cymharu Dau Destun",
        subtitle: "Dadansoddi metrigau darllenadwyedd dau destun a'u cymharu",
        button: "Cymharu Testunau",
    },

    textAnnotator: {
        title: "Dadansoddiad testun",
        editText: "Golygu Testun",
        legend: { a1: "A1", a2: "A2", b1: "B1", b2plus: "B2+" },
        tooltip: { cefr: "CEFR: {value}" },
        pos: {
            verb: "Berf",
            noun: "Enw",
            adverb: "Adferf",
            adjective: "Ansoddair",
            particle: "Geiryn",
            article: "Bannod",
            preposition: "Arddodiad",
            pronoun: "Rhagenw",
            verbNoun: "Berfenw",
            conjunction: "Cysylltair",
            determiner: "Banodol",
            numeral: "Rhifair",
        },
        mutation: {
            soft: "Treiglad Meddal",
            nasal: "Treiglad Trwynol",
            aspirate: "Treiglad Llaes",
        },
    },

    comparisonTable: {
        text1: "Testun 1",
        text2: "Testun 2",
        title: "Cymhariaeth ochr yn ochr",
        winnerBadge: "Mae {winner} yn fwy darllenadwy yn gyffredinol",
        sections: {
            overview: "Trosolwg",
            vocabulary: "Geirfa",
            grammar: "Gramadeg",
            syntax: "Cystrawen",
        },
        rows: {
            readability: "Sgôr darllenadwyedd (canradd)",
            cefrLevel: "Lefel y CEFR",
            wordCount: "Cyfrif Geiriau",
            sentenceCount: "Cyfrif Brawddegau",
            avgSentenceLength: "Hyd y brawddegau ar gyfartaledd",
            ttr: "Cymhareb Fath Tocyn",
            a1Coverage: "Cwmpas A1",
            a2Coverage: "Cwmpas A2",
            b1Coverage: "Cwmpas B1",
            stopWords: "Ataleiriau",
            totalMutations: "Cyfanswm y treigladau",
            softMutations: "Treigladau meddal",
            verbNouns: "Berfenwau",
            avgTreeDepth: "Dyfnder coed cyfartalog",
            avgHeadDistance: "Pellter pen cyfartalog",
            clausesPerSentence: "Cymalau / brawddeg",
            branchingFactor: "Ffactor canghennu",
        },
    },

    resultsBox: {
        // Draft translation - please have a Welsh speaker review.
        analysisResult: "Canlyniad Dadansoddiad",
        empty: "Cyflwynwch destun i weld dadansoddiad",
        outdatedWarning: "Mae'r testun wedi cael ei olygu ers i'r dadansoddiad hwn gael ei gynhyrchu. Dadansoddwch y testun eto i ddiweddaru'r canlyniadau.",
        tabs: {
            overview: "Trosolwg",
            proficiency: "Hyfedredd",
            vocabulary: "Geirfa",
            grammar: "Grammadeg",
            structure: "Strwythur",
            suggestions: "Awgrymiadau",
        },
        cefr: {
            heading: "Lefel Hyfedredd Iaith (CEFR)",
            miniLabel: "CEFR",
            confidence: "{percent}% hyder",
            link: "Gweld disgrifiadau swyddogol y CEFR  -",
            infoTip: "Mae'r Fframwaith Cyfeirio Cyffredin Ewrop ar gyfer Ieithoedd (CEFR) yn diffinio lefel iaith o A1 (defnyddwyr sylfaenol) i C2 (defnyddwyr hyfedr). Dyma amcangyfrif gan fodel dysgu peirianyddol.",
            descriptions: {
                A1: "Mynediad — yn deall ymadroddion sylfaenol ac yn eu defnyddio.",
                A2: "Sylfaen — yn gallu cyfathrebu er mwyn cyflawni tasgau syml o ddydd i ddydd.",
                B1: "Canolradd — yn gallu ymdrin â'r rhan fwyaf o sefyllfaoedd a fyddai'n codi wrth deithio.",
                B2: "Uwch — yn gallu cyfathrebu'n eithaf rhugl a digymell.",
            },
        },
        overview: {
            readabilitySection: "Darllenadwyedd",
            textSizeSection: "Maint y testun",
            gulpeaseName: "Mynegai Gulpease (Wedi'i addasu) - Sgôr darllenadwyedd",
            gulpeaseLabel: "Uwch = mwy darllenadwyr",
            avgSentenceLengthName: "Hyd y Brawddegau ar gyfartaledd",
            avgSentenceLengthLabel: "Nifer y geiriau fesul brawddeg",
            totalWordsName: "Cyfanswm Geiriau",
            totalWordsLabel: "Cyfrif Geiriau",
            sentencesName: "Brawddegau",
            sentencesLabel: "Cyfanswm brawddegau",
        },
        proficiency: {
            coverageSection: "Cwmpas geiriau fesul lefel CEFR",
            coverageInfoTip: "Dangosir cyfradd o'r geiriau yn eich testun sy'n perthyn i bob rhestr geirfa CEFR.",
            levels: {
                a1: "A1 — Mynediad",
                a2: "A2 — Sylfaen",
                b1: "B1 — Canolradd",
                other: "B2+ neu'n anhysbys",
            },
            basicVocabName: "Geirfa craidd (A1–A2)",
            basicVocabLabel: "o'r holl eiriau",
            intermediateName: "Canolradd (B1)",
            intermediateLabel: "o'r holl eiriau",
        },
        vocabulary: {
            diversityName: "Amrywiaeth Geirfa",
            diversityLabel: "Cymhareb Math-Tocyn (TTR)",
            note: "Mae'r gymhareb Math-Tocyn (TTR) yn mesur pa mor amrywiol yw'ch geirfa. Mae sgôr sy'n agosach at 1.0 yn golygu bod y rhan fwyaf o'r geiriau'n unigryw; mae sgôr is yn awgrymu ailadrodd.",
            noteInfoTip: "Cymhareb Math-Tocyn = geiriau unigryw ÷ cyfanswm geiriau. Mae cymhareb uwch yn golygu rhagor o amrywiaeth er bod testunau hwy yn debygol o sgorio'n is.",
            cefrAccordion: {
                title: "Cwmpas Rhestr Geiriau'r CEFR (A1 – B1)",
                a1Matches: "Cyfateb i A1",
                a2Matches: "Cyfateb i A2",
                b1Matches: "Cyfateb i B1",
                matchesLabel: "Geiriau unigryw",
            },
            frequencyAccordion: {
                title: "Bandiau Amlder Geiriau (K1–K6)",
                note: "Mae bandiau amlder geiriau yn dangos pa mor gyffredin yw'r geiriau. Geiriau K1 yw'r geiriau mwyaf cyffredin (e.e. \"a\", \"y\"), geiriau K6+ yw'r geiriau prinnaf.",
            },
            stopwordsAccordion: {
                title: "Geiriau swyddogaeth (Ataleiriau)",
                note: "Geiriau sydd â fawr ddim ystyr ar eu pen eu hunain (e.e. \"y\", \"yn\", \"am\") yw geiriau swyddogaeth. Gellir disgwyl cyfradd uchel yn y Gymraeg.",
                functionWordsName: "Geiriau swyddogaeth",
                functionWordsLabel: "O'r holl docynnau",
                uniqueFunctionWordsName: "Geiriau swyddogaeth unigryw",
                uniqueFunctionWordsLabel: "Ffurfiau unigryw",
            },
        },
        grammar: {
            posSection: "Rhannau Ymadrodd",
            pos: {
                verbs: "Berfau",
                nouns: "Enwau",
                adverbs: "Adferfau",
                adjectives: "Ansoddeiriau",
                conjunctions: "Cysyllteiriau",
                particles: "Geirynnau",
                articles: "Y fannod",
                prepositions: "Arddodiaid",
                pronouns: "Rhagenwau",
            },
            verbFormsSection: "Ategion berfol",
            verbForms: {
                pluperfect: "Y Gorberffaith",
                imperfect: "Yr Amherffaith",
                impersonal: "Yr Amhersonol",
                subjunctive: "Y Modd Dibynnol", // (was mismatched with "Pluperfect" in previous version )
                conditional: "Yr Amodol",
                verbNouns: "Berfenwau",
            },
            mutationsSection: "Treigladau",
            mutationsInfoTip: "Mae treigladau yn newid seiniau ar ddechrau geiriau ac yn cael eu sbarduno gan strwythurau gramadegol penodol.",
            mutations: {
                total: "Cyfanswm y treigladau",
                soft: "Treigladau Meddal",
                nasal: "Treigladau Trwynol",
                aspirate: "Treigladau Llaes",
                hProthesis: "Anadliad Caled",
            },
        },
        structure: {
            complexitySection: "Cymhlethdod brawddegau",
            complexityInfoTip: "Mae'r mesurau hyn yn disgrifio pa mor gymhleth yw strwythur gramadegol eich brawddegau. Mae dyfnder a changhennau uwch yn gyffredinol yn dynodi iaith fwy cymhleth.",
            headDistance: "Pellter pen cyfartalog",
            headDistanceInfoTip: "Yn dangos pa mor bell oddi wrth ei gilydd y mae geiriau cysylltiedig yn tueddu i fod mewn brawddeg. Mae gwerthoedd uwch fel arfer yn golygu bod brawddegau'n anoddach i'w dilyn oherwydd bod syniadau wedi'u gwasgaru.",
            avgTreeDepth: "Dyfnder coed cyfartalog",
            avgTreeDepthInfoTip: "Yn dangos faint o haenau o wybodaeth sydd fel arfer wedi'u pacio mewn brawddeg. Mae gwerthoedd uwch fel arfer yn golygu strwythurau brawddegau mwy cymhleth.",
            maxTreeDepth: "Dyfnder coed mwyaf",
            maxTreeDepthInfoTip: "Cymhlethdod y frawddeg fwyaf cymhleth yn y testun. Mae gwerthoedd uwch yn awgrymu bod o leiaf un frawddeg yn cynnwys sawl haen o wybodaeth.",
            branchingFactor: "Ffactor canghennu cyfartalog",
            branchingFactorInfoTip: "Yn dangos faint o wybodaeth sydd ynghlwm wrth bob rhan o frawddeg. Gall gwerthoedd uwch dynodi ysgrifennu dwysach, sy'n fwy cyfoethog o ran gwybodaeth.",
            clauseSection: "Strwythur cymalau",
            subjectRatio: "Cymhareb goddrychau",
            subjectRatioInfoTip: "Yn dangos pa mor aml mae brawddegau'n nodi'n glir pwy neu beth sy'n cyflawni gweithred. Mae gwerthoedd uwch fel arfer yn gwneud testun yn haws i'w ddeall.",
            leftRightRatio: "Cymhareb canghennu chwith-dde",
            leftRightRatioInfoTip: "Yn dangos a yw iaith yn tueddu i roi geiriau disgrifiadol neu ddibynnol cyn neu ar ôl y prif air y maent yn cysylltu ag ef (fel y ferf). Mae trefn y geiriau yn bwysig e.e. byddai disgwyl i'r Gymraeg, sydd fel arfer yn rhoi'r goddrych ar ôl y ferf, ddangos mwy o batrwm \"ar ôl\" na'r Saesneg. Mae cymhareb o gwmpas 1 yn golygu ei bod yn gytbwys. Mae gan frawddegau Cymraeg gymhareb sydd fel arfer yn is nag 1.",
            clausesPerSentence: "Cymalau fesul brawddeg",
            totalClauses: "Cyfanswm cymalau",
            auxiliaryVerbs: "Berfau cynorthwyol",
            auxiliaryVerbsInfoTip: "Berfau cynorthwyol megis ffurfiau o 'bod' neu 'gwneud' sy'n helpu i fynegi amser, modd, neu agwedd. Maent yn rhan arferol o iaith naturiol. Maent fel arfer yn fwy presennol mewn lleferydd anffurfiol.",
        },
        suggestions: {
            section: "Awgrymiadau yn seiliedig ar eich testun",
            placeholderNote: "Warning: This is a placeholder reflecting a potential final result.", // TODO: translate
            none: "Dim awgrymiadau",
            items: {
                repetitiveVocab: {
                    title: "Geirfa ailadroddus",
                    body: "Ceir sawl enghraifft o ailadrodd yn eich testun. Ceisiwch ddefnyddio ystod eang o eirfa i'w wneud yn fwy diddorol.",
                },
                longSentences: {
                    title: "Brawddegau hir",
                    body: "Mae eich brawddegau'n eithaf hir ar gyfartaledd. Gall eu torri'n rai byrrach wneud eich testun yn haws i'w ddilyn.",
                },
                noSoftMutations: {
                    title: "Heb ganfod treigladau meddal",
                    body: "Ni chanfuwyd unrhyw dreigladau meddal. Gwiriwch fod geiriau wedi'u treiglo ar ôl sbarduniadau treiglad (e.e. 'yn', 'am').",
                },
                simpleStructures: {
                    title: "Strwythurau brawddegau syml",
                    body: "Mae'r rhan fwyaf o frawddegau yn dilyn strwythur syml. Gall ychwanegu is-gymalau wneud i'r testun deimlo'n fwy naturiol.",
                },
                lowB1Coverage: {
                    title: "Cwmpas geirfa B1 isel",
                    body: "Ychydig iawn o eiriau Canolradd (B1) a ddarganfuwyd. Os ydych chi'n ysgrifennu ar gyfer dysgwyr lefel ganolradd, ystyriwch gyflwyno geirfa fwy amrywiol.",
                },
            },
        },
    },

    featuresPage: {
        title: "Gwybodaeth am nodweddion",
        subtitle: "Mae'r dudalen hon yn cynnwys gwybodaeth am yr holl nodweddion a ystyriwyd wrth ddadansoddi'r darllenadwyedd.",
        computationsIntro: "Mae'r metrig hwn yn cynnwys y cyfrifiadau canlynol:",
        surface: {
            title: "Ystadegau Lefel Uchel",
            body: "Mae ystadegau lefel uchel yn rhoi mewnweliadau sylfaenol sy'n seiliedig ar y testun yn unig, heb ystyried y cyd-destun nac ystyr y geiriau. Mae'r metrigau hyn yn cynnig trosolwg cyflym o ddarllenadwyedd y testun. Po uchaf yw'r rhif ar gyfer y canlyniadau hyn, y lleiaf darllenadwy yw'r testun.",
            computations: [
                "Cyfrif Brawddegau",
                "Cyfrif Tocynnau - Mae tocyn yn cynnwys gair ac atalnodi.",
                "Cyfrif Rhifau",
                "Cyfrif Geiriau",
                "Hyd Brawddeg ar gyfartaledd",
                "Geiriau Unigryw",
                "Cymhareb Fath Tocyn (CFT)",
                "Cymhareb Tocyn Math (CTM)",
            ],
        },
        vocab: {
            title: "Rhestrau Geirfa",
            body: "Mae rhestrau geirfa yn rhannu'r testun mewn grwpiau wedi'u categoreiddio fel termau academaidd, geiriau cyffredin, neu ataleiriau. Mae'r rhestrau hyn yn helpu i werthuso lefel anhawster y testun a'i berthnasedd i gynulleidfaoedd penodol.",
            computations: [
                "Rhestr Amlder - Yn cymharu'r testun â set ddata amlder geiriau CorcenCC",
                "Rhestr CBAC - Yn cymharu'r testun â'r rhestrau a grëwyd ar gyfer lefelau hyfedredd myfyrwyr CBAC.",
                "Ataleiriau - Yn cymharu dwy restr o ataleiriau â'r testun. Y cyntaf yw rhestr gyda geiriau Cymraeg yn unig, yr ail yw rhestr sy'n cynnwys geiriau Cymraeg a Saesneg sy'n ymddangos yn gyffredin mewn testun Cymraeg.",
            ],
        },
        pos: {
            title: "Tagio Rhannau Ymadrodd (PoS)",
            body: "Mae tagio rhannau ymadrodd yn cynnwys labelu pob gair yn y testun gyda'i rôl ramadegol fel enw, berf, ansoddair, neu adferf ayyb. Mae'r dadansoddiad hwn yn helpu i nodi strwythur brawddegau a deall sut mae gwahanol eiriau'n gweithredu mewn cyd-destun.",
            listIntro: "Mae'r rhannau ymadrodd canlynol yn rhan o'r dadansoddiad:",
            items: [
                { term: "Berfau:", description: "Mae berfau yn cyfleu gweithredoedd neu gyflwr. e.e. bwyta, hoffi. Mae gwahanol fathau o ferfau ac maent yn cael eu rhedeg yn ôl person a rhif. Mae berf sydd ddim wedi cael ei rhedeg yn aros ar ffurf berfenw. e.e. bwyta, dysgu." },
                { term: "Enwau:", description: "Mae enwau yn dynodi pobl, lleoedd neu bethau. e.e. ci, ysgol. Yn y Gymraeg, gall enwau fod yn fenywaidd neu'n wrywaidd, yn unigol neu'n lluosog, yn gyffredin neu'n briod." },
                { term: "Ansoddeiriau:", description: "Mae ansoddeiriau yn disgrifio enwau e.e. mawr, da." },
                { term: "Adferfau:", description: "Mae adferfau yn disgrifio sut, pryd neu ble mae rhwywbeth yn ei ddigwydd e.e. ddoe." },
                { term: "Y Fannod", description: "Y neu Yr" },
                { term: "Arddodiaid:", description: "Mae arddodiaid yn dangos perthynas rhwng dau Ymadrodd Enwol." },
                { term: "Cysyllteiriau:", description: "Mae cysyllteiriau yn cysylltu cymalau e.e. a, neu." },
                { term: "Rhifolion:", description: "Rhifau: e.e. un, dau" },
                { term: "Rhagenwau:", description: "Gellir defnyddio rhagenwau yn lle enw neu Ymadrodd Enwol e.e. fi, chi." },
                { term: "Geirynnau:", description: "Geiriau gramadegol fel yn neu nid" },
                { term: "Banodolion:", description: "Set gaeedig o eiriau a ddefnyddir yn lle’r fannod e.e. y tŷ - pob tŷ" }, 
                { term: "Atalnodi:", description: "Symbolau sy'n helpu i greu strwythur mewn testun e.e. atalnod (,), atalnod llawn (.)" },
            ],
            tensesIntro: "Dyma amseroedd a ffurfiau gwahanol y ferf:",
            tenses: [
                "Y Presennol: Dw, Rwyt, Mae...",
                "Y Gorffennol: Bues, Prynais, Prynodd...", 
                "Imperfect: Roeddwn, Roedd...", 
                "Y Dyfodol: Bydda i, Bydd...", 
                "Y Perffaith: Dw i wedi...", 
                "Yr Amodol: Byddwn i, Byddai...", 
                "Y Dyfodol Dibynnol: bo", 
                "Y Ffurfiau Gorchmynnol: Cadwch, Darllenwch",
                "Y Gorberffaith: Buasai (Roedd e wedi)", 
                "Berfau perthynol: sydd, piau", 
                "Amhersonol: Gofynnir, eir", 
            ],
            computations: [
                "Cwmpas tagiau PoS: Nifer y geiriau a dagiwyd.",
                "Nifer y mathau o dagiau PoS: Cyfanswm y cwmpas o wahanol dagiau PoS.",
                "Cyfrif Lema: Cyfanswm y ffurfiau wedi'u lemmatio.",
                "Nifer y Rhannau Ymadrodd: Cyfrif rhannau ymadrodd.",
                "Nifer cyfartalog y rhannau ymadrodd fesul brawddeg: wedi'i normaleiddio fesul brawddeg.",
                "Cymhareb y math o ran ymadrodd ar gyfer pob tag: Cymhareb ar gyfer pob is-fath o ran ymadrodd.",
            ],
        },
        mutations: {
            title: "Treigladau",
            body: "Mae treigliadau yn newidiadau i gytsain gychwynnol y gair a sbardunir gan wahanol resymau geiriol a morffogystrawennol. Mae tri math o dreiglad yn y Gymraeg: Treiglad Meddal, Treiglad Trwynol a Threiglad Llaes. Yn ogystal, mae rhagddodi <h> (anadliad caled) yn gallu digwydd pan fydd geiriau yn dechrau gyda llafariad. Er nad yw'n cael ei ystyried yn draddodiadol yn fath o dreiglad, mae anadliad caled hefyd yn cael ei sbarduno gan resymau gramadegol.",
            computations: ["Nifer y Treigladau", "Math o dreiglad ar gyfartaledd fesul brawddeg"],
        },
        syntactic: {
            title: "Nodweddion Cystrawennol",
            body: "Mae cystrawen yn dylanwadu ar drefn geiriau mewn brawddeg. Yn aml, mae'r Gymraeg yn dilyn y patrwm Berf - Goddrych - Gwrthrwch. Gwneir y dadansoddiad cystrawennol drwy goed dadansoddi dibyniaethau drwy UDPipe.",
            computations: [
                "Dyfnder y Goeden: y llwybr hiraf o'r ferf wreiddyn i unrhyw nod dail.",
                "Lled y goeden: yr uchafswm o ddibynyddion uniongyrchol (plant) o dan unrhyw nod.",
                "Ffactor canghennu: Nifer cyfartalog y plant fesul nod.",
                "Pellter pen: Nifer cyfartalog y geiriau rhwng pob dibynnydd a'i ben.",
                "Dwysedd cymal: Nifer y pennau cymal fesul tocyn.",
                "Cymhareb dail gyfartalog: Cyfradd o'r nodau dail terfynol i gyfanswm y nodau.",
            ],
        },
    },

    aboutPage: {
        title: "Am y Prosiect",
        entries: {
            background: {
                tag: "Cefndir",
                title: "Cefndir y Prosiect",
                text: "Datblygwyd Proffiliadur fel rhan o brosiect IAA (Cyfrif Cyflymu Traweffaith) yr AHRC a oedd yn cynnwys cydweithwyr o Brifysgol Caerdydd.",
            },
            people: {
                tag: "Pobl",
                title: "Y Tîm",
                roles: {
                    lead: "Arweinydd y Prosiect",
                    colead: "Cyd-arweinydd",
                    ra: "Cynorthwyydd Ymchwil",
                },
            },
            advisory: {
                tag: "Ymgynghorol",
                title: "Grŵp Ymgynghorol y Prosiect",
                text: "Roedd Grŵp Ymgynghorol y Prosiect yn cynnwys cynrychiolwyr o'r sefydliadau canlynol:",
                list: ["CBAC", "Y Ganolfan Dysgu Cymraeg Genedlaethol", "Llywodraeth Cymru"],
            },
            affiliation: {
                tag: "Sefydliad",
                title: "Sefydliad",
                text: "Prifysgol Caerdydd",
            },
        },
    },
};

export default cy;